module.exports = __webpack_public_path__ + "img/logo-fle.5518fd64.jpg";